import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPropertyHouseCreateRequestDTO,
	postPropertyHouseV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePostPropertyHouseMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(
			(requestContract: ClientPropertyHouseCreateRequestDTO) =>
				postPropertyHouseV2(requestContract),
		),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: PortfolioKeys.propertyList() });
		},
	});
};
